import { render, staticRenderFns } from "./SaleDelete.vue?vue&type=template&id=fb1bf41c&"
import script from "./SaleDelete.vue?vue&type=script&lang=js&"
export * from "./SaleDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports